<template>
  <div>
    <Row :gutter="4">
      <Col span="5">
        <Input search v-model="mailboxsSearchKey" :placeholder="$t('configuration_management.schedules.queryByName')" @on-search="searchSchedule()"/>
      </Col>
      <Col span="4">
        <add-mailboxs></add-mailboxs>
      </Col>
    </Row>
  </div>
</template>
<script>
  import AddMailboxs from './AddMailboxs'
  import TableMailboxs from './TableMailboxs'

  var tableMailboxs = TableMailboxs;
  export default {
    name: 'MailboxsSearch',
    components: {
      AddMailboxs
    },
    data() {
      return {
        mailboxsSearchKey: '',
        mailboxSearchName: ''
      }
    },
    methods: {
      searchSchedule() {
        // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
        eventBus.$emit('mailboxSearchName', this.mailboxsSearchKey);
        tableMailboxs.methods.showAll();
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/monitor_mailbox_configuration/MailboxsSearch.vue